import type { Role } from "./accountConstants";

type Account = {
  roles?: Role[];
};

export function accountHasRole(account: Account, role: Role): boolean {
  return account.roles ? account.roles.includes(role) : false;
}
